import { Modal, Button } from "react-bootstrap";
import styles from '../pa_checklist.module.scss';
import Tabela from "../../../Misc/Tabela/Tabela";

const PAChecklistModalLocalizacao = (params) => {
  const { produto, cor_produto, localizacoes, showModalLocalizacao, setShowModalLocalizacao } = params;

  const localizacao_columns = [
    { name: 'Localização', selector: row => row.localizacao_produto },
    { name: 'Caixa', selector: row => row.caixa },
    { name: 'Descrição', selector: row => row.desc_localizacao_produto },
  ];

  return (
    <Modal
      show={showModalLocalizacao}
      centered
      size={'lg'}
      onHide={() => setShowModalLocalizacao(false)}
      backdropClassName={styles.backdrop_z_override}
    >
      <Modal.Header style={{ fontWeight: '500' }} closeButton>
        Localizações Possíveis | Produto: {produto} | Cor: {cor_produto}
      </Modal.Header>
      <Modal.Body className={styles.modal_body} style={{ fontWeight: '500' }}>
        <Tabela
          columns={localizacao_columns}
          data={localizacoes}
          pagination={false}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant={'success'}
          style={{ margin: '0px auto' }}
          className={styles.footer_btn_processamento}
          onClick={() => setShowModalLocalizacao(false)}
        >
          Voltar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PAChecklistModalLocalizacao;
